import React, {RefObject} from "react"
import HasBodyStyles from "./body.less"
import {connect} from "react-redux"
import SimpleField from "../simpleField/simpleField"
import ErrorField from "../errorField/errorField"
import TableField from "../tableField/tableField"
import JsonToTable from "../JsonToTable"

export class HasDataBody extends React.Component<any, any> {
    private allMessageRef: RefObject<any>
    private allMessageBoxRef: RefObject<any>

    constructor(props: any) {
        super(props)
        // this.state = {
        //     allMessageStyle: {maxHeight: `${650}px`},
        // }
        this.allMessageRef = React.createRef()
        this.allMessageBoxRef = React.createRef()
    }

    renderNormalTable = () => {
        console.log(this.props.normalTableJson)
        return this.props.normalTableJson[0].pageData.map((item: any, index: number) => {
            if (item.objectType === "table with line") {
                return <JsonToTable key={`${item.objectType}_${index}`} data={item} />
            } else {
                return <div>198</div>
            }
        })
    }

    render() {
        console.log(this.props.markdownName)
        return (
            <div className={HasBodyStyles.showMessageBox} ref={this.allMessageBoxRef}>
                {this.props.markdownName === "normalTable" ? null : (
                    <div ref={this.allMessageRef} className={HasBodyStyles.allMessage2}>
                        <div className={HasBodyStyles.simpleAndTableMegBox}>
                            <span className={HasBodyStyles.fieldNavText}>已识别字段：</span>
                            <div className={HasBodyStyles.simpleField}>
                                <table className={HasBodyStyles.tableStyle}>
                                    <SimpleField key={`simpleField${new Date().getTime()}`} />
                                </table>
                            </div>
                            <TableField key={`tableField${new Date().getTime()}`} />
                        </div>
                        <div className={HasBodyStyles.errorMegBox} key={new Date().getTime()}>
                            <span className={HasBodyStyles.fieldNavText}>
                                {this.props.errorField.length === 0 ? "" : "未识别字段："}
                            </span>
                            <div className={HasBodyStyles.simpleField}>
                                <table className={HasBodyStyles.tableStyle}>
                                    <ErrorField key={`errorField${new Date().getTime()}`} />
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
export default connect((state: any) => {
    return {
        normalTableJson: state.normalTableJson,
        markdownName: state.markdownName,
        errorField: state.errorField,
    }
})(HasDataBody)
